import { createSelector } from 'reselect';
import { entries, flatMap, flow, get, keys, map, mapValues, pick, pickBy } from 'lodash/fp';

export const mapBonuses = flow(
  entries,
  map(([key, value]) => ({
    key,
    player_id: value
  }))
);

export function getSelection(selections, bonusesChosen, playerPositions, teamPositions) {
  const mapPlayers = flow(
    pick(keys(playerPositions)),
    mapValues(
      flow(
        pickBy(p => !p.isTeam),
        keys,
        map(idStr => idStr.replace('PLAYER_', ''))
      )
    )
  );
  const mapTeams = flow(
    pick(keys(teamPositions)),
    flatMap(
      flow(
        pickBy(p => p.isTeam),
        keys,
        map(idStr => idStr.replace('TEAM_', ''))
      )
    )
  );

  return {
    players: mapPlayers(selections),
    teams: mapTeams(selections),
    bonus_selections: mapBonuses(bonusesChosen)
  };
}

const selectionToPost = createSelector(
  get('lineUp.selections'),
  get('lineUp.bonusesChosen'),
  get('challenge.playerPositions'),
  get('challenge.teamPositions'),
  getSelection
);

export default selectionToPost;
